import { Helper } from 'libraries/Helper';

export class Timer {
	loading = false;
	public timer: any;

	/**
	 *
	 * @param interval Interval in ms
	 * @param callback Function/event to be executed when the timer ticks. **IMPORTANT** you MUST bind the function like this: this.timerTick.bind(this)
	 */
	constructor(public interval: any, public callback: any) {}
	start() {
		this.timer = setInterval(this.callback, this.interval);
	}
	stop() {
		clearInterval(this.timer);
	}
	restart() {
		clearInterval(this.timer);
		this.timer = setInterval(this.callback, this.interval);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/libraries/Timer.ts